import { render } from "./Statistics.vue?vue&type=template&id=eaaa8968"
import script from "./Statistics.vue?vue&type=script&lang=js"
export * from "./Statistics.vue?vue&type=script&lang=js"
script.render = render

export default script